import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const QUESTION_TYPES = [
  { value: "multiple-choice", label: "Multiple Choice" },
  { value: "multiple-select", label: "Multiple Select" },
  { value: "true-false", label: "True / False" },
  { value: "fill-in-the-blank", label: "Fill in the Blank" },
  { value: "multi-fill", label: "Multi Fill" },
  { value: "table", label: "Table (fill-in)" },
  { value: "image-fill", label: "Image fill (drag boxes)" },
  { value: "matching", label: "Matching" },
  { value: "ordering", label: "Ordering" },
  { value: "essay", label: "Essay" },
  { value: "short-answer", label: "Short Answer" },
  { value: "drawing", label: "Drawing / Diagram" },
];

export { QUESTION_TYPES };

const QuestionTypeSelector = ({ value, onChange, error, disabled }) => (
  <FormControl fullWidth error={!!error} disabled={disabled}>
    <InputLabel>Question Type</InputLabel>
    <Select value={value || ""} label="Question Type" onChange={onChange}>
      {QUESTION_TYPES.map((t) => (
        <MenuItem key={t.value} value={t.value}>
          {t.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default QuestionTypeSelector;
